module.exports = __webpack_public_path__ + "static/media/b13-大清邮局.fa6cc690.png";